import { render, staticRenderFns } from "./sanitary_table.vue?vue&type=template&id=34d6b2d5&"
import script from "./sanitary_table.vue?vue&type=script&lang=js&"
export * from "./sanitary_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports